module.exports = __webpack_public_path__ + "img/checkbox.c97ebbe2.svg";